import Model, { attr } from '@ember-data/model';
import { cached } from '@glimmer/tracking';

export default class CustomBookingAttributeModel extends Model {
  @attr('string') name!: string;
  @attr('string') description!: string;

  @cached
  get tagCode(): string {
    return this.name ? `{{booking.${this.name}}}` : '';
  }

  @cached
  get isVisible(): boolean {
    return this.name !== 'lock_code';
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'custom-booking-attribute': CustomBookingAttributeModel;
  }
}
